import React from "react";
import ReactDOM from "react-dom";
import FilterApp from "./FilterApp";
import { BrowserRouter } from "react-router-dom";
const params = new Proxy(new URLSearchParams(window.location.search), {
  get: (searchParams, prop) => searchParams.get(prop),
});

const apps = document.getElementsByClassName("filter-app");

if (apps) {
  for (let i = 0; i < apps.length; i++) {
    let app = apps[i];

    let showFilter = app.getAttribute("data-filter");
    let language = app.getAttribute("data-language");
    let type = app.getAttribute("data-type");
    let limit = app.getAttribute("data-limit");
    let promoted = app.getAttribute("data-promoted");
    let output = app.getAttribute("data-output");
    let nodeId = app.getAttribute("data-node-id");
    let map = app.getAttribute("data-map");
    let taxonomy = app.getAttribute("data-taxonomy");
    let data = app.getAttribute("data-data");
    let spotlight = app.getAttribute("data-spotlight");
    let ajax = app.getAttribute("data-ajax");
    let viewMode = app.getAttribute("data-view-mode");

    ReactDOM.render(
      <BrowserRouter>
        <FilterApp
          language={language ? language : "nl"}
          fetchDataUrl={"/filter-api/fetch-data"}
          type={type}
          ajax={ajax}
          spotlight={spotlight}
          data={data}
          nodeId={nodeId}
          output={output}
          map={map == "1" ? true : false}
          taxonomy={taxonomy}
          numberItems={limit}
          showFilter={showFilter == "1" ? true : false}
          onlyPromoted={promoted}
          term={params.term}
          entityViewMode={viewMode}
          itemsPerPage={20}
        />
      </BrowserRouter>,
      app
    );
  }
}
